import DatePickerLocale from 'rmc-date-picker/lib/locale/zh_CN';
export default DatePickerLocale;



// WEBPACK FOOTER //
// ./components/date-picker-view/locale/zh_CN.tsx